<template>
  <div id="turnstile-container"></div>
</template>

<script setup lang="ts">
const widget = ref();
useHead({
  script: [
    {
      id: 'CloudflareTurnstile',
      src: 'https://challenges.cloudflare.com/turnstile/v0/api.js',
      type: 'text/javascript',
      async: true,
      defer: true,
      onload() {
        if (widget.value === undefined) {
          widget.value = turnstile.render("#turnstile-container", {
            sitekey: siteKey,
            callback: onTurnstileSuccess,
          });
        }
      }
    },
  ],
});

const emit = defineEmits(['success']);
const siteKey = useRuntimeConfig().public.turnstile.siteKey;
const onTurnstileSuccess = (token: string): void => {
  emit('success', token);
}


</script>

<style scoped></style>
